import { AuthContext } from 'context';
import { setLayout } from 'context';
import { useMaterialUIController } from 'context';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import crudsService from 'services/cruds-service';


const Dashboard = () => {
  const { id } = useParams();
  const [htmlSrc, setHtmlSrc] = useState('');
  const [, dispatch] = useMaterialUIController();
  const authContext = useContext(AuthContext)

  useEffect(() => {
    setLayout(dispatch, "page");
    let url = process.env.REACT_APP_ENV == 'dev' ? process.env.REACT_APP_API_URL : `${location.origin}/api`
    setHtmlSrc(`${url}/public/images/dashboard/${id}`)
    if(!authContext.isAuthenticated){
      crudsService.dashboardEvent(id)
    }
  }, [id]);

  return (
    <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      {
        htmlSrc && 
        <iframe
          src={htmlSrc}
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            overflow: 'hidden',
          }}
          // title="Rendered HTML"
        />
      }
    </div>
  );
};

export default Dashboard;
